export default {
  places: []
}
